export default {
	type_of_client: "",
	type_of_purchase: "",
	property_price: "",

	is_purchasing_single_home: false,
	already_own_other_property: false,
	is_first_time_buyer: false,
	purchase_is_shared_ownership: false,
	is_purchasing_part_built_site: false,
	is_purchasing_commercial: false,
	purchase_involves_divorce: false,
	is_purchasing_multiple_properties: false,
	is_purchasing_subsale: false,
	purchase_has_connected_parties: false,
	could_be_uninhabitable: false,
	potential_mixed_use: false,
	transfer_of_equity: false,
	probate: false,
	is_purchasing_other: false,

	leasehold: false,
	uk_resident: true,
	completing_soon: false,
	days_until_completion: "",
	// handle_submission: true,
	// expedite_calculation: true,
};
